// extracted by mini-css-extract-plugin
export default {"giftPointBody":"Terms_giftPointBody__luwb3","okBtn":"Terms_okBtn__Gdb3G","cashNotes":"Terms_cashNotes__MzgEG"};